module.exports = __webpack_public_path__ + "static/media/first.ffe2da33.jpg";